import Flickity from 'flickity'
import { TimelineMax, TweenMax, Power4 } from 'gsap'
import { $, each, debounce } from '../util'

const MainHeroSlider = (() => {
  const changeActiveIndex = (slider, index) => {
    const activeIndexContainer = slider.querySelector('.js-main-hero-slider-active')

    if (activeIndexContainer) {
      const old = slider.querySelector('.c-main-hero-slider__control-number-active')
      old.classList.add('c-main-hero-slider__control-number-old')

      const newIndex = document.createElement('div')
      newIndex.className = 'c-main-hero-slider__control-number c-main-hero-slider__control-number-new'
      newIndex.innerText = `0${index + 1}`

      activeIndexContainer.appendChild(newIndex)
      const newIndexEl = slider.querySelector('.c-main-hero-slider__control-number-new')

      const subTl = new TimelineMax()

      subTl
        .to(old, 0.42, {
          y: '-100%',
          ease: Power4.easeInOut,
        })
        .to(newIndex, 0.42, {
          y: '-100%',
          ease: Power4.easeInOut,
          onComplete: () => {
            old.remove()

            newIndexEl.style = ''
            newIndexEl.classList.remove('c-main-hero-slider__control-number-new')
            newIndexEl.classList.add('c-main-hero-slider__control-number-active')
          },
        }, '-=0.3')
    }
  }

  const init = () => {
    const mainHeroSlider = $('.js-main-hero-slider')
    each(mainHeroSlider, (i, mhs) => {
      const slides = mhs.querySelectorAll('.js-main-hero-slide')
  
      const mhsInstance = new Flickity(mhs, {
        cellSelector: '.js-main-hero-slide',
        cellAlign: 'left',
        pageDots: false,
        freeScroll: false,
        prevNextButtons: false,
        wrapAround: true,
        draggable: false,
        setGallerySize: false
      })

      const next = mhs.querySelector('.js-main-hero-slider-next')
      const progressBar = mhs.querySelector('.js-main-hero-slider-progress')

      if (next) {
        next.addEventListener('click', function() {
          mhsInstance.next()
        })
      }

      if (progressBar) {
        progressBar.style.width = `${(1 / slides.length) * 100}%`

        mhsInstance.on('select', (index) => {
          const ourProgress = (index + 1) / slides.length

          changeActiveIndex(mhs, index)

          progressBar.style.width = `${ourProgress * 100}%`
        })
      }
    })
  }

  return {
    init,
  }
})()

export default MainHeroSlider



// WEBPACK FOOTER //
// app/javascript/scripts/components/MainHeroSlider.js